import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import LoadingSpinner from "../Components/LoadingSpinner";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment/moment";
import momenttimezone from "moment-timezone";

import { formatTime, getTrainingData, getLanguage, formatFromTime, formaToTime , gettrainerList } from '../Utils/utils';
import Sidebar from "../Components/Sidebar/Sidebar";
import Topbar from "../Components/Topbar/Topbar";
import Select from 'react-select';
import TrainingModal from "../Components/Modals/TrainingModal";
import CustomSearch from "../Components/CustomSearch";
import config from "../config/config";
import axios from "axios";
import SuccessModal from "../Components/Modals/SuccessModal";
import WarningModal from "../Components/Modals/WarningModal";
import { Link } from "react-router-dom";

const Training = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([])
  const [maxPageLimit, setMaxPageLimit] = useState(5)
  const [pageCount, setPageCount] = useState(2);
  const [selectRowsArr, setSelectRowsArr] = useState([]);
  const [trainingArray, setTrainingArray] = useState([]);
  const [trainerList , setTrainerList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isSuccessShowRoll, setIsSuccessShowRoll] = useState(false);
  const [trainingModal, setTrainingModal] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [isSearchable, setIsSearchable] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [row , setRow] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);  
  const [selectedTime, setSelectedTime] = useState(null); 
  const handleFilterChange = (e) => {setFilterText(e.target.value);};
  const [isShowRoll, setIsShowRoll] = useState(false);


  const getAllTrainingData = async () => {
    setIsLoading(true)
    var res = await getTrainingData()
    if (res.status == 200) {
      setTrainingArray(res.data)
      setIsLoading(false)
    }
  }

  const getAllTrainerList = async () => {
    setIsLoading(true)
    var res = await gettrainerList()
    if (res.status == 200) {
      setTrainerList(res.data)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAllTrainingData()
    getAllTrainerList()
    setPageCount(data.length / maxPageLimit)
  }, [])

  useEffect(() => {
    getAllTrainingData();
  }, [reloadData])

  const trainerOptions = trainerList.map(trainer => ({
    label: trainer.username, 
    value: trainer.id,      
  }));

  const Columns = [
    {
      id: 1,
      name: "Student Id",
      width:'110px',
      selector: (row) => 
        <div style={{
          whiteSpace: 'normal', 
          wordBreak: 'break-word', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          fontSize:'12px' 
        }}>
          {row.LD_SID}
      </div>
    },
    {
      id: 2,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper' style={{fontSize:'12px'}}>{row.RANK}</div>
          </div>
        </>,
      width: "80px",
      sortable: true,
    },
    {
      id: 3,
      name: "First Name",
      cell: (row) => (
        <div style={{ 
          whiteSpace: 'normal', 
          wordBreak: 'break-word', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          fontSize:'12px' 
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 4,
      name: "Last Name",
      cell:(row) =>(
        <div style={{ 
          whiteSpace: 'normal', 
          wordBreak: 'break-word', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          fontSize:'12px' 
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 5,
      name: "Home Email",
        cell:(row) =>(
        <div style={{ 
          whiteSpace: 'normal', 
          wordBreak: 'break-word', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          fontSize:'12px'
        }}>
          {row.HOME_EMAIL}
        </div>
      ),
      width: "250px"
    },
    {
      id: 6,
      name: "New Course No.",
      sortable: true,
      width: "140px",
      cell: (row) => <div 
      style={{
        fontSize:'12px',
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
        }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{row.serialized_course_number}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
    }, 
    {
      id: 7,
      name: "Start Date",
      sortable: true,
      cell: (row) => <div style={{fontSize:'12px'}}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.new_start_date).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
        id: 8,
        name: "MON",
        cell: (row) => <div className='cell-link py-1'
        style={{
            whiteSpace: 'normal', 
            wordBreak: 'break-word', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis',
            fontSize:'12px' 
        }}
            onClick={() => {
            setShowModal(true)
            setSelectedRow(row)
            }}>
            <div className="display-time">
            {row.MON_FROM ? <>
                <div>{formatFromTime(row?.MON_FROM)}</div>
                <div>-</div>
                <div>{formaToTime(row?.MON_TO)}</div>
            </> : ''}
            </div>
        </div>,
        ignoreRowClick: true,
        allowOverflow: true,
        width: "70px"
    },
    {
    id: 9,
    name: "TUE",
    cell: (row) => <div className='cell-link py-1' 
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px' 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.TUE_FROM ? <>
            <div>{formatFromTime(row?.TUE_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.TUE_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 10,
    name: "WED",
    cell: (row) => <div className='cell-link py-1' 
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px' 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.WED_FROM ? <>
            <div>{formatFromTime(row?.WED_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.WED_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 11,
    name: "THUR",
    cell: (row) => <div className='cell-link py-1'
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px' 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.THUR_FROM ? <>
            <div>{formatFromTime(row?.THUR_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.THUR_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 12,
    name: "FRI",
    cell: (row) => <div className='cell-link py-1'
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px' 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.FRI_FROM ? <>
            <div>{formatFromTime(row?.FRI_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.FRI_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 13,
    name: "SAT",
    cell: (row) => <div className='cell-link py-1'
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px' 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.SAT_FROM ? <>
            <div>{formatFromTime(row?.SAT_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.SAT_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 14,
    name: "SUN",
    cell: (row) => <div className='cell-link py-1'
    style={{
        whiteSpace: 'normal', 
        wordBreak: 'break-word', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontSize:'12px', 
    }}
        onClick={() => {
        setShowModal(true)
        setSelectedRow(row)
        }}>
        <div className="display-time">
        {row.SUN_FROM ? <>
            <div>{formatFromTime(row?.SUN_FROM)}</div>
            <div>-</div>
            <div>{formaToTime(row?.SUN_TO)}</div>
        </> : ''}
        </div>
    </div>,
    ignoreRowClick: true,
    allowOverflow: true,
    width: "70px"
    },
    {
    id: 15,
    name: "Schedule Training on",
        cell:(row) =>(
        <div style={{ 
          whiteSpace: 'normal', 
          wordBreak: 'break-word', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          fontSize:'12px'
        }}>
          {row.training_on ? momenttimezone.tz(`${row.training_on}`, 'YYYY-MM-DD HH:mm:ss', 'UTC').format('MM/DD/YYYY hh:mm a') : ""}
        </div>
    ),
    width: "150px"
    },
    {
        id: 16,
        name: "Confirmed",
            cell:(row) =>(
            <div style={{ 
            whiteSpace: 'normal', 
            wordBreak: 'break-word', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            fontSize:'12px'
            }}>
            {row.training_accepted == null ? '-' : row.training_accepted}
            </div>
        ),
        width: "100px"
    },
    {
        id: 17,
        name: "Meeting Created",
            cell:(row) =>(
            <div style={{ 
            whiteSpace: 'normal', 
            wordBreak: 'break-word', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            fontSize:'12px'
            }}>
            {row.webex_created == null ? '-' : row.webex_created}
            </div>
        ),
        width: "130px"
    },
    {
        id: 18,
        name: "Student Attended",
            cell:(row) =>(
            <div style={{ 
            whiteSpace: 'normal', 
            wordBreak: 'break-word', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            fontSize:'12px'
            }}>
            {row.student_attended_training == null ? '-' : row.student_attended_training}
            </div>
        ),
        width: "140px"
    },
    {
      name: "Selected Trainer",
      cell: (row) => (
        <div
          style={{
            overflow: 'visible',
            textOverflow: 'ellipsis',
            fontSize: '12px',
            position: 'relative',
          }}
        >
          <Select
            name="trainer"
            className="basic-single"
            classNamePrefix="select"
            isSearchable={isSearchable}
            options={trainerOptions}
            value={trainerOptions.find((option) => option.value === row.trainer_id)}
            onChange={(selectedOption) => {
              SaveTrainerData(row.id, selectedOption.value, updateRowState);
            }}
            menuPlacement="auto" 
            menuPosition="fixed" 
            styles={{
              control: (base) => ({
                ...base,
                width: '120px',
                minWidth: '120px',
                maxWidth: '120px',
              }),
              menu: (base) => ({
                ...base,
                width: '120px',
                minWidth: '120px',
                maxWidth: '120px',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </div>
      ),
      width: "150px",
    },    
    {
      id: 16,
      name: "Action",
      cell: (row) => 
      <div className='cell-link'
      ><>
        <i className="text-primary fas fa-calendar-alt ml-3" title="Pick Date"
            onClick={() => {
              setRow(row);
              setTrainingModal(true);
            }}>
        </i>
        <Link to={"/training/" + row.generated_hash}>
          <i className="text-secondary fas fa-eye ml-3" title="Archive"></i>
        </Link>
        </>
    </div>,
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };

  const updateRowState = (rowId, trainerId) => {
    setTrainingArray((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId ? { ...row, trainer_id: trainerId } : row
      )
    );
  };

  const onCloseRoll = () => {
    setIsSuccessShowRoll(false)
    getTrainingData()
  }

  const SaveTrainerData = async (rowId, trainerId, updateRowState) => {
    setIsLoading(true);
    let path = config.siteUrl;
  
    try {
      const response = await axios.post(
        `${path}/classes/save-trainer`,
        {
          id: rowId,
          trainer_id: trainerId,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
  
      setIsLoading(false);
      updateRowState(rowId, trainerId);
      setIsSuccessShowRoll(true);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      setIsLoading(false);
      return null;
    }
  };

  const  SubmitData = async () => {
    setIsLoading(true);
    let path = config.siteUrl;
  
    try {
      const response = await axios.post(
        `${path}/classes/schedule-training-webex`,
        {
          id: row?.id,
          schedule_date: selectedDate,
          schedule_time: selectedTime?.value
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      setIsLoading(false);
      getAllTrainingData();
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      setIsLoading(false);
      return null;
    }
  };
  
  const onProceedRoll = () =>{
    SubmitData();
    setIsShowRoll(false);
    setIsSuccessShowRoll(true);
  }

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className='new-card' style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                  <div className="row">
                      <div className="col-lg-9">
                        <div className='heading-text'>
                          Ready for Training Data
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                  </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-md-12">
                      {trainingArray.length > 0 ?
                        <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                          <div className="card-body m-p-0 p-0" style={{marginTop:'-20px'}}>
                            <DataTableExtensions
                              columns={Columns}
                              data={trainingArray.filter((item) =>Object.values(item).some((value) =>String(value).toLowerCase().includes(filterText.toLowerCase().trim())))}
                              print={false}
                              export={false}
                              filter={false}
                              style={{ display: 'none' }}
                            >
                              <DataTable
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                selectableRows
                                // selectableRowsNoSelectAll={true}
                                onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                                persistTableHead
                                progressPending={isLoading}
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10 , 25 , 50, 100]}
                                highlightOnHover
                                customStyles={{
                                  table: {
                                      style: {
                                          border: '1px solid #ccc', 
                                      },
                                  },
                                  headCells: {
                                      style: {
                                          backgroundColor: '#8A8A8A',
                                          color: '#ffffff',
                                      },
                                  },
                              }}
                              />
                            </DataTableExtensions>

                            <Row className="w-100 display-center mt-5">
                              <div className="btn-box">
                                <div className="main-btn">
                                  Training
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                        :
                        <div className="no-record">
                          There are no records to display.
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {trainingModal == true ?
          <TrainingModal
            row={row}
            trainingModal={trainingModal}
            setTrainingModal={setTrainingModal}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            isShow = {isShowRoll}
            setIsShow = {setIsShowRoll}
            onProceed = {onProceedRoll}
          />
          : null}
        {isSuccessShowRoll == true ?
          <SuccessModal
            isSuccessShow={isSuccessShowRoll}
            setIsSuccessShow={setIsSuccessShowRoll}
            onClose={onCloseRoll}
          />
          : null}
        {isShowRoll == true ?
          <WarningModal
            isShow={isShowRoll}
            setIsShow={setIsShowRoll}
            onProceed={onProceedRoll}
          />
        : null}
      </div>
    </>
  )
}

export default Training
